export default __webpack_public_path__ + "static/media/db_footer.9e83d417.svg";